module.exports = __webpack_public_path__ + "static/sam-e45285339f092acf6942809de248a24b.mp3";